import AxiosConnect from "@/common/api/AxiosConnect";
class EndpointsHandler {
  constructor(hostDefault, alternativeHost, validationFn = () => false) {
    this.hostDefault = hostDefault;
    this.alternativeHost = alternativeHost;
    this.validationFn = validationFn;
  }

  async execute(path, method, params = {}) {
    const useAlt = this.validationFn();
    const selectedHost = useAlt ? this.alternativeHost : this.hostDefault;
    const axiosConfig = {
      baseURL: selectedHost,
      timeout: 60000,
    };
    return await AxiosConnect.instance(axiosConfig).request({
      url: path,
      method,
      data: params,
    });
  }
}

export default EndpointsHandler;
